import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../components/ui/alert-dialog';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <AlertDialog open={true}>
      <AlertDialogContent className="max-w-lg w-full p-4">
        <AlertDialogHeader>
          <AlertDialogTitle>Something Went Wrong!</AlertDialogTitle>
          <AlertDialogDescription>
            An unexpected error occurred. Please refresh the page to continue.
          </AlertDialogDescription>
          <div className="text-sm text-red-500 bg-gray-100 p-2 rounded mt-2 overflow-auto max-h-32 max-w-full">
            {error?.message}
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={() => {
              resetErrorBoundary(); // Reset error boundary
              window.location.reload(); // Refresh page
            }}
          >
            Refresh Page
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ErrorFallback;
